import TopicTwo from "../../../components/platform-contents/pips-trade-app-contents/TopicTwo";

const PipsTradeAppContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Trade with The Pips App</h1>
            <p>
              Designed for the modern trader, The Pips Trade App combines
              functionality, security, and convenience to deliver a professional
              trading experience from the palm of your hand.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Intuitive Interface</h4>
                </div>
                <p>
                  Built for clarity and efficiency, the app simplifies complex
                  trading tools into a clean, intuitive design.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Lightning-Fast Execution</h4>
                </div>
                <p>
                  Engineered for speed, The Pips Trade App ensures minimal
                  latency and superior performance, even during high market
                  volatility
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>24/7 Accessibility</h4>
                </div>
                <p>
                  Access your account, monitor positions, and execute trades
                  anytime, anywhere, across all global markets.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PipsTradeAppContentFive;
